import {
    SmallTextHelper
} from '../PrismicHelpers';

export const seriesHelper = (response) => {

    const seriesData = response.result;

    let seriesObject = seriesData.map(series => {
        return {
            uid: SmallTextHelper(series.id),
            name: SmallTextHelper(series.data.series_title),
            description: SmallTextHelper(series.data.series_description),     
            image: SmallTextHelper(series.data.series_image.url)
        }
    })
    return seriesObject;
}

export const podcastPageHelper = (response) => {
    const podcastData = response.result;
    let podcastObject = podcastData.map(podcast => {
        return {
            uid: SmallTextHelper(podcast.id),
            podcast_title: SmallTextHelper(podcast.data.podcast_page_title),
            podcast_summary: SmallTextHelper(podcast.data.podcast_summary),
        }
    })
    return podcastObject;
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-custom-helpers/PodcastHelper.js